import React, { useEffect, useState } from 'react';
import { Col, Divider, Row, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
//
import ConfirmModal from './ConfirmModal';
import Heading from '../../../components/heading/heading';
import {
  getCarAmigoDetail,
  requestCarInspection,
  startPayment,
  startPurchaseOrder,
} from '../../../redux/carImport/carAmigo/actionCreator';
import { Button } from '../../../components/buttons/buttons';
import moment from 'moment';
import './carAmigo.css'

const CarAmigoInfo = ({ carAmigoId, carName, variant }) => {
  const dispatch = useDispatch();
  const [inspectModalVisible, setInspectModalVisible] = useState(false);
  const [purchaseModalVisible, setPurchaseModalVisible] = useState(false);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [offeredPrice, setOfferedPrice] = useState(0);
  const { isLoggedIn, carAmigoDetail, carInspectionId, carPaymentId, carPurchaseId } = useSelector(state => {
    return {
      isLoggedIn: state.carAmigo.isLoggedIn,
      carAmigoDetail: state.carAmigo.carAmigoDetail,
      carInspectionId: state.carAmigo.carInspectionId,
      carPurchaseId: state.carAmigo.carPurchaseId,
      carPaymentId: state.carAmigo.carPaymentId,
    };
  });

  useEffect(() => {
    setOfferedPrice(carAmigoDetail?.smaxPrice);
  }, [carAmigoDetail]);

  const {carChecking, purchaseOrder, pay} = carAmigoDetail?.vehicle || {};

  const reports = []
  const reportLang = Object.keys(carChecking?.reports || {})[0]
  if (carChecking?.reports[reportLang]?.length) {
    reports.push(...carChecking?.reports[reportLang])
  }

  const formatDate = (date) => date ? moment(date).format('dddd, MMMM D, YYYY h:mm A') : '-';
  const formatBoolean = (value) => value ? 'True' : 'False';

  const fetchCarDetail = () => dispatch(getCarAmigoDetail(carAmigoId));
  const handleInspectionClick = async () => {
    const res = await dispatch(requestCarInspection(carAmigoId));
    // TODO confirm status code
    if (res.status === 200) fetchCarDetail();
  };
  const handlePurchaseOrder = async () => {
    const res = await dispatch(startPurchaseOrder(carAmigoId, offeredPrice));
    // TODO confirm status code
    if (res.status === 200) fetchCarDetail();
  };
  const handlePayment = async () => {
    const res = await dispatch(startPayment(carAmigoId));
    if (res.status === 200) fetchCarDetail();
  };
  useEffect(() => {
    dispatch(getCarAmigoDetail(carAmigoId));
  }, []);
  if (!isLoggedIn) return <></>;
  if (!carAmigoDetail)
    return (
      <div className="spin">
        <Spin />
      </div>
    );
  return (
    <>
      <Divider />
      <Col xs={24} gutter={[10, 10]} style={{ marginTop: '20px', padding: 0 }}>
        <Row xs={24}>
          <Heading className="pdbr__title" as="h4">
            Order Management
          </Heading>
        </Row>
        <Row xs={24} gutter={20}>
          <Col {...(variant === "row" ? { md: 12, lg: 8 } : { lg: 24 })}>
            {/* Car Inspection */}
            <div className='mb-12' style={carChecking?.init? { background: "lightgray", padding: "0 15px 15px" } : undefined }>
              <div className='section-header-wrapper'>
                <h3 style={{ marginBottom: 0 }}>Inspection</h3>
                <div>
                  {!carChecking?.init ? (
                    <Button
                      onClick={() => setInspectModalVisible(true)}
                      size="small"
                      style={{ backgroundColor: '#155BDC', color: '#fff' }}
                      disabled={carInspectionId}
                    >
                      Initiate
                    </Button>
                  ) : !carChecking?.end ? (
                    <strong style={{ color: '#155BDC' }}>In Progress</strong>
                  ) : (
                    <strong style={{ color: 'green' }}>Ended</strong>
                  )}
                </div>
              </div>

              {carChecking?.init && (
                <div>
                  <ul style={{ marginLeft: '1rem' }}>
                    <li><strong>Status:</strong> {carChecking?.status ?? '-'}</li>
                    <li><strong>Initiated:</strong> {formatBoolean(carChecking?.init)}</li>
                    <li><strong>Initiated Date:</strong> {formatDate(carChecking?.initDate)}</li>
                    <li><strong>End:</strong> {formatBoolean(carChecking?.end)}</li>
                    <li><strong>End Date:</strong> {formatDate(carChecking?.endDate)}</li>
                    <li><strong>Closed:</strong> {formatBoolean(carChecking?.closed)}</li>
                    <li><strong>Date:</strong> {formatDate(carChecking?.date)}</li>
                    {
                      reports.length > 0 && 
                      <>
                        <li><strong>Reports</strong></li>
                        <ul style={{ marginLeft: '1rem' }}>
                          {reports?.map((report, index) => (
                            <li key={index}>
                              <a href={`${process.env.REACT_APP_CAR_AMIGO_API}${report}`} target="_blank" rel="noopener noreferrer">
                                {report?.split('-').pop()}  
                              </a>
                            </li>
                          ))}
                        </ul>
                      </>
                    }
                  </ul>
                </div>
              )}
            </div>
          </Col>
          <Col {...(variant === "row" ? { md: 12, lg: 8 } : { lg: 24 })}>
            {/* Purchase Order */}
            <div className='mb-12' tyle={purchaseOrder?.init? { background: "lightgray", padding: "0 15px 15px" } : undefined }>
              <div className='section-header-wrapper'>
                <h3 style={{ marginBottom: 0 }}>Purchase Order</h3>
                <div>
                  {!purchaseOrder?.init ? (
                    <Button
                      onClick={() => setPurchaseModalVisible(true)}
                      size="small"
                      style={{ backgroundColor: '#155BDC', color: '#fff' }}
                      disabled={carPurchaseId}
                    >
                      Initiate
                    </Button>
                  ) : !purchaseOrder?.end ? (
                    <strong style={{ color: '#155BDC' }}>In Progress</strong>
                  ) : (
                    <strong style={{ color: 'green' }}>Ended</strong>
                  )}
                </div>
              </div>

              {purchaseOrder?.init && (
                <div>
                  <ul style={{ marginLeft: '1rem' }}>
                    <li><strong>Initiated:</strong> {formatBoolean(purchaseOrder?.init)}</li>
                    <li><strong>Initiated Date:</strong> {formatDate(purchaseOrder?.initDate)}</li>
                    <li><strong>End:</strong> {formatBoolean(purchaseOrder?.end)}</li>
                    <li><strong>End Date:</strong> {formatDate(purchaseOrder?.endDate)}</li>
                  </ul>
                </div>
              )}
            </div>
          </Col>
          <Col {...(variant === "row" ? { md: 12, lg: 8 } : { lg: 24 })}>
            {/* Payment */}
            <div className='mb-12' tyle={pay?.init? { background: "lightgray", padding: "0 15px 15px" } : undefined }>
              <div className='section-header-wrapper'>
                <h3 style={{ marginBottom: 0 }}>Payment</h3>
                <div>
                  {!pay?.init ? (
                    <Button
                      onClick={() => setPaymentModalVisible(true)}
                      size="small"
                      style={{ backgroundColor: '#155BDC', color: '#fff' }}
                      disabled={carPaymentId}
                    >
                      Initiate
                    </Button>
                  ) : !pay?.end ? (
                    <strong style={{ color: '#155BDC' }}>In Progress</strong>
                  ) : (
                    <strong style={{ color: 'green' }}>Ended</strong>
                  )}
                </div>
              </div>

              {pay?.init && (
                <div>
                  <ul style={{ marginLeft: '1rem' }}>
                    <li><strong>Initiated:</strong> {formatBoolean(pay?.init)}</li>
                    <li><strong>Initiated Date:</strong> {formatDate(pay?.initDate)}</li>
                    <li><strong>End:</strong> {formatBoolean(pay?.end)}</li>
                    <li><strong>End Date:</strong> {formatDate(pay?.endDate)}</li>
                    <li><strong>Paid:</strong> {formatBoolean(pay?.paid)}</li>
                    <li><strong>Delivered Date:</strong> {formatDate(pay?.deliveredDate)}</li>
                  </ul>
                </div>
              )}
            </div>
          </Col>
        </Row>
        

      </Col>
      <ConfirmModal
        visible={inspectModalVisible}
        content={
          <p>
            Initiate Vehicle Inspection for <b> {carName}</b>?
          </p>
        }
        handleSubmit={handleInspectionClick}
        onCancel={() => setInspectModalVisible(false)}
        title="Car Inspection"
      />
      <ConfirmModal
        visible={purchaseModalVisible}
        content={
          <p>
            Initiate Purchase Order for <b>{carName}</b> for offered price € <input type='number' className='offerPriceInput' value={offeredPrice}/> ?
          </p>
        }
        handleSubmit={handlePurchaseOrder}
        onCancel={() => setPurchaseModalVisible(false)}
        title="Purchase Car"
      />
      <ConfirmModal
        visible={paymentModalVisible}
        content={
          <p>
            Initiate Payment for <b>{carName}</b>?
          </p>
        }
        handleSubmit={handlePayment}
        onCancel={() => setPaymentModalVisible(false)}
        title="Car Payment"
      />
    </>
  );
};

export default CarAmigoInfo;
